// Globals
import { useTranslation } from 'react-i18next';

// Store
import { useAppState } from '@/store';
import { selectStepsProgresses } from '../../feature';

// Models
import { ContractStepProgress } from '@/models/propertyProgress.model';
import { StepType } from '@/models/step.model';

// Components
import {
  ResetStepButton,
  StepCard,
  StyledContractTag,
  StyledList,
  StyledListRow,
  StyledRow,
  StyledText,
} from '../../components';

// Helpers
import { finalStatuses } from '../../helpers';

type TContractProgressContainerProps = {
  hideResetButton?: boolean;
};

const ContractProgressContainer = ({ hideResetButton = false }: TContractProgressContainerProps) => {
  const { t } = useTranslation('property');
  const stepsProgresses = useAppState(selectStepsProgresses);
  const contractProgress = stepsProgresses?.[StepType.CONTRACT] as ContractStepProgress;

  if (!contractProgress) return null;

  return (
    <StepCard title={t('step_contract')} status={contractProgress.status}>
      <StyledRow>
        {!hideResetButton && finalStatuses.includes(contractProgress.status) && (
          <ResetStepButton
            propertyId={contractProgress?.property_id}
            stepName={StepType.CONTRACT}
            shouldResetStepData={false}
          />
        )}
      </StyledRow>
      <StyledList>
        {contractProgress?.signers?.map((signer, idx) => {
          return (
            <StyledListRow key={signer.signed_at}>
              <StyledText>
                {t(`contract_${signer?.signer_type}_count`, { count: idx + 1 })}
                {` (${signer?.signer_name}): `}
              </StyledText>
              <StyledContractTag $status={signer?.signing_status}>
                {signer?.signing_status ? t(`signing_status_${signer?.signing_status}`) : '-'}
              </StyledContractTag>
            </StyledListRow>
          );
        })}
      </StyledList>
    </StepCard>
  );
};

export default ContractProgressContainer;
